"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VanillaGenerator = void 0;
var translation_1 = __importDefault(require("../../../translation"));
var VanillaGenerator = /** @class */ (function () {
    function VanillaGenerator() {
        //HELPER LOADING
        this.stylesAdded = false;
        this.addDocumentStyles();
    }
    VanillaGenerator.prototype.getRow = function (obj, type, attr) {
        var _a;
        if (attr === void 0) { attr = {}; }
        var theme = {};
        if (type) {
            theme = {
                padding: '15px',
                margin: '20px 0px',
                borderRadius: '5px',
            };
        }
        var div = document.createElement('div');
        div.innerHTML = (_a = obj === null || obj === void 0 ? void 0 : obj.html) !== null && _a !== void 0 ? _a : '';
        div.className = 'm-row' + ((obj === null || obj === void 0 ? void 0 : obj.class) ? ' ' + obj.class : '');
        for (var key in attr) {
            if (attr.hasOwnProperty(key)) {
                div.setAttribute(key, attr[key]);
            }
        }
        Object.assign(div.style, __assign(__assign({ width: '100%', display: 'flex', alignItems: 'center' }, theme), obj === null || obj === void 0 ? void 0 : obj.css));
        return div;
    };
    VanillaGenerator.prototype.showErrorMessage = function (error, errorFieldId) {
        if (errorFieldId === void 0) { errorFieldId = 'error_msg'; }
        var errorFieldObj = document.getElementById(errorFieldId);
        if (errorFieldObj) {
            errorFieldObj.textContent = translation_1.default.t(error);
            errorFieldObj.style.display = 'block';
        }
        else {
            console.error('No error message field defined so we added our own');
            errorFieldObj = this.getRow({
                css: { background: 'rgb(255, 59, 59)' },
                html: translation_1.default.t(error),
            }, 'error', { id: errorFieldId });
            var form = document.querySelector('form');
            form === null || form === void 0 ? void 0 : form.insertAdjacentElement('afterbegin', errorFieldObj);
        }
        this.scrollToPageElementOffset('#' + errorFieldId, 120, 750);
    };
    VanillaGenerator.prototype.scrollToPageElementOffset = function (elementIdentifier, offset, duration) {
        if (offset === void 0) { offset = 180; }
        if (duration === void 0) { duration = 750; }
        var pageScroll = document.documentElement.scrollTop || document.body.scrollTop;
        console.log('helper pageScroll', elementIdentifier, offset, duration, pageScroll);
        var element = document.querySelector(elementIdentifier);
        if (element &&
            (pageScroll > offset + 50 || pageScroll < offset - 50)) {
            var targetPosition = element.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        }
    };
    VanillaGenerator.prototype.createLoadingScreen = function (infoText) {
        this.addDocumentStyles();
        if (!document.getElementById('full-screen-loading')) {
            var loader = this.getLoaderElement();
            document.body.appendChild(loader);
        }
    };
    VanillaGenerator.prototype.deleteLoadingScreen = function () {
        var fullScreenLoading = document.getElementById('full-screen-loading');
        if (fullScreenLoading) {
            fullScreenLoading.remove();
        }
        var ldsRingElements = document.querySelectorAll('.lds-ring');
        ldsRingElements.forEach(function (element) { return element.remove(); });
    };
    VanillaGenerator.prototype.getLoader = function () {
        var loader = document.createElement('div');
        loader.className = 'lds-ring lds-ring-black';
        loader.innerHTML = '<div></div><div></div><div></div><div></div>';
        return loader;
    };
    VanillaGenerator.prototype.addDocumentStyles = function () {
        if (!this.stylesAdded) {
            var style = document.createElement('style');
            style.type = 'text/css';
            style.innerHTML = "\n        #full-screen-loading{\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            z-index:10000;\n            position:fixed;\n            top:0px;left:0px;\n            width:100vw;\n            height:100vh;\n            background:rgba(0,0,0,0.7);\n            backdrop-filter: blur(3px);\n        }\n        .lds-ring-black {\n            margin: 0px auto;\n            display: block;\n            margin-bottom:50px;\n        }\n        .lds-ring-black div {\n            border: 8px solid #222 !important;\n            border-color: #222 transparent transparent transparent !important;\n        }\n        .lds-ring {\n            display: inline-block;\n            position: relative;\n            width: 80px;\n            height: 80px;\n        }\n        .lds-ring div {\n            box-sizing: border-box;\n            display: block;\n            position: absolute;\n            width: 64px;\n            height: 64px;\n            margin: 8px;\n            border: 8px solid #fff;\n            border-radius: 50%;\n            animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n            border-color: #fff transparent transparent transparent;\n        }\n        .lds-ring div:nth-child(1) {\n            animation-delay: -0.45s;\n        }\n        .lds-ring div:nth-child(2) {\n            animation-delay: -0.3s;\n        }\n        .lds-ring div:nth-child(3) {\n            animation-delay: -0.15s;\n        }\n        @keyframes lds-ring {\n            0% {\n                transform: rotate(0deg);\n            }\n            100% {\n                transform: rotate(360deg);\n            }\n        }\n      ";
            document.head.appendChild(style);
            this.stylesAdded = true;
        }
    };
    VanillaGenerator.prototype.getLoaderElement = function () {
        var loaderContainer = document.createElement('div');
        loaderContainer.id = 'full-screen-loading';
        loaderContainer.innerHTML = "\n      <div class=\"lds-ring\">\n        <div></div><div></div><div></div><div></div>\n      </div>\n    ";
        return loaderContainer;
    };
    VanillaGenerator.prototype.addErrorToFormField = function (formField, errorMessage) {
        this.removeErrorFromFormField(formField);
        var errorElement = document.createElement('span');
        errorElement.style.color = 'red';
        errorElement.className = 'form-error';
        errorElement.id = "error-".concat(formField.id.replace('#', ''));
        errorElement.setAttribute('data-link', formField.id);
        errorElement.textContent = "*".concat(errorMessage || 'This field is required');
        var formFieldElement = document.querySelector(formField.id);
        if (formFieldElement) {
            formFieldElement.insertAdjacentElement('afterend', errorElement);
            if (formFieldElement.tagName === 'INPUT' || formFieldElement.tagName === 'TEXTAREA' || formFieldElement.tagName === 'SELECT') {
                formFieldElement.style.border = 'red 1px solid';
            }
        }
    };
    VanillaGenerator.prototype.removeErrorFromFormField = function (formField) {
        // Implementation for removing error from form field
        var errorElement = document.querySelector("#error-".concat(formField.id.replace('#', '')));
        if (errorElement) {
            errorElement.remove();
        }
        var formFieldElement = document.querySelector(formField.id);
        if (formFieldElement) {
            formFieldElement.style.border = '';
        }
    };
    return VanillaGenerator;
}());
exports.VanillaGenerator = VanillaGenerator;
